import { EPaddleCountryKey } from "../types/paddle-country-key.js";
import { EPaddleCountryValueEnglish } from "../types/paddle-country-value-english.js";
import { EPaddleCountryValueGerman } from "../types/paddle-country-value-german.js";
/**
 * Get key-value pares as object of countries available in the Paddle checkout process
 *
 * @param {string} language Language of values
 * @return {object} key-value object with all countries
 */ function paddleCountriesKeyValue(language) {
    const keys = Object.entries(EPaddleCountryKey);
    let values;
    switch(language){
        case "de":
            values = Object.entries(EPaddleCountryValueGerman);
            break;
        default:
            values = Object.entries(EPaddleCountryValueEnglish);
            break;
    }
    const keyValue = {};
    for (const [enumKey, key] of keys){
        const [, value] = values.find((value)=>value[0] === enumKey);
        keyValue[key] = value;
    }
    return keyValue;
}
export { paddleCountriesKeyValue };
